import React from "react";
import { useHistory } from "react-router-dom";
import DateUtils from "Utils/DateUtils";
import LinearLoader from "./LinearLoader";
import { handleViewRecordsClick } from "../utils/viewRecordsNavigation";
import { ReactComponent as EmailSubjectIcon } from "Assets/svg/outbox/emailSubject.svg";
import { ReactComponent as LinkedinIcon } from "Assets/svg/linkedInOutlined.svg";

const isLinkedInTaskType = (taskType = "") =>
  taskType?.toLowerCase().startsWith("linkedin") || taskType?.toLowerCase().startsWith("li");

const LatestRepliesWidget = ({ replies = [], isLoading = false }) => {
  const history = useHistory();

  if (isLoading) {
    return <LinearLoader visible={true} />;
  }

  if (!replies.length) {
    return (
      <div className="latestRepliesWidgetEmpty">
        <div className="latestRepliesWidgetEmptyIcon">
          <i className="material-icons-outlined">forum</i>
        </div>
        <span className="latestRepliesWidgetEmptyText">No replies yet</span>
      </div>
    );
  }

  return (
    <div className="latestRepliesWidgetWrap">
      <div className="latestRepliesWidgetList">
        {replies.map((item, idx) => {
          const { task = {}, contact = [] } = item || {};
          const { taskType = "", touchPoint = {}, replyDate = "" } = task || {};
          const { email = "" } = contact?.[0] || {};
          const isLinkedIn = isLinkedInTaskType(taskType);
          const message = touchPoint?.repliedSubject || touchPoint?.subject || "";

          return (
            <div className="latestRepliesWidgetRow" key={task?.id || idx}>
              <div className={`latestRepliesWidgetIcon ${isLinkedIn ? "isLinkedIn" : "isEmail"}`}>
                {isLinkedIn ? <LinkedinIcon /> : <EmailSubjectIcon />}
              </div>
              <div className="latestRepliesWidgetInfo">
                <span className="latestRepliesWidgetEmail">{email || "—"}</span>
                <span className="latestRepliesWidgetMessage">{message || "—"}</span>
              </div>
              <span className="latestRepliesWidgetDate">
                {replyDate ? DateUtils.formatDateByMonthText(replyDate) : ""}
              </span>
            </div>
          );
        })}
      </div>
      <button
        type="button"
        className="latestRepliesWidgetViewMoreBtn"
        onClick={() => handleViewRecordsClick("LATEST_REPLIES", history)}
      >
        View More →
      </button>
    </div>
  );
};

export default LatestRepliesWidget;
